import { Stack } from "expo-router";
import React from "react";
import colors from '@/constants/Colors';

export default function OnboardingLayout() {
  return (
    <Stack
      screenOptions={{
        headerShown: true,
        headerStyle: {
          backgroundColor: colors.primary,
        },
        headerTintColor: colors.accent,
        headerBackButtonDisplayMode: 'minimal',
      }}
    >
      <Stack.Screen name="index" options={{ headerShown: false, title: 'Back' }} />
      <Stack.Screen name="your-details" options={{ title: "Your Details" }} />
      <Stack.Screen name="your-experience" options={{ title: 'Your Experience' }} />
      <Stack.Screen name="competency-questions" options={{ title: 'Competency Questions' }} />
      <Stack.Screen name="referee-cv" options={{ title: 'CV and References' }} />
    </Stack>
  );
}